<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Heading from '../../layouts/heading.vue';
import api from "../../../api";
import Swal from "sweetalert2";
import { v4 as uuidv4 } from 'uuid';

export default {
  page: {
    title: "PCN",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Heading },
  data() {
    return {
      pcns: [],
      page: {
        title: "PCN",
        lastUpdated: false,
        addNewBtn: true,
        addNewModalTitle: 'Create New PCN',
        formData: {},
        schema: {
          pcncode: {
            type: 'text',
            label: 'PCN Code',
            placeholder: 'Enter PCN Code',
            required: true,
            info: false,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          pcnname: {
            type: 'text',
            label: 'PCN Name',
            placeholder: 'Enter PCN Name',
            required: true,
            info: false,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          ccgcode: {
            type: 'text',
            label: 'CCG Code',
            placeholder: 'Enter CCG Code',
            required: true,
            info: false,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          ccgname: {
            type: 'text',
            label: 'CCG Name',
            placeholder: 'Enter CCG Name',
            required: true,
            info: false,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          stpcode: {
            type: 'text',
            label: 'STP Code',
            placeholder: 'Enter STP Code',
            required: true,
            info: false,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          stpname: {
            type: 'text',
            label: 'STP Name',
            placeholder: 'Enter STP Name',
            required: true,
            info: false,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          regioncode: {
            type: 'text',
            label: 'Region Code',
            placeholder: 'Enter Region Code',
            required: true,
            info: false,
            character_count: 0,
            wrapper_class: 'col-6'
          },
          regionname: {
            type: 'text',
            label: 'Region Name',
            placeholder: 'Enter Region Name',
            required: true,
            info: false,
            character_count: 0,
            wrapper_class: 'col-6'
          }
        },
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false
      },      
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "pcncode", sortable: true, label: 'PCN Code' },
        { key: "pcnname", sortable: true, label: 'PCN Name' },
        { key: "ccgcode", sortable: true, label: 'CCG Code' },
        { key: "ccgname", sortable: true, label: 'CCG Name' },
        { key: "stpcode", sortable: true, label: 'STP Code' },
        { key: "stpname", sortable: true, label: 'STP Name' },
        { key: "regioncode", sortable: true, label: 'Region Code' },
        { key: "regionname", sortable: true, label: 'Region Name' }
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.pcns.length;
    },
    // currentUser() {
    //   return JSON.parse(localStorage.getItem('currentUser'));
    // },
  },
  methods: {
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    sleep(seconds) {
      return new Promise(resolve => setTimeout(resolve, seconds * 1000));
    },
    async createStp(val) {
      var data = {
        code: val.stpcode,
        name: val.stpname,
        region_code: val.regioncode,
        region_name: val.regionname,
        additionalProp1: {}
      };
      return await new Promise((resolve)=>{
        api.post('/api/stps', data)
        .then((response) => {
          resolve(response.data);
        }, (error) => {
          console.log(error);
        });
      });
    },
    async createCcg(val, stpId) {
      var data = {
        code: val.ccgcode,
        name: val.ccgname,
        stpId: stpId,
        additionalProp1: {}
      };
      return await new Promise((resolve)=>{
        api.post('/api/ccgs', data)
        .then((response) => {
          resolve(response.data);
        }, (error) => {
          console.log(error);
        });
      });
    },
    async createPcn(val, ccgId) {
      var data = {
        code: val.pcncode,
        name: val.pcnname,
        ccgId: ccgId,
        additionalProp1: {}
      };
      return await new Promise((resolve)=>{
        api.post('/api/pcns', data)
        .then((response) => {
          resolve(response.data);
          Swal.fire("PCN Created!", "PCN Created Successfully.", "success");
        }, (error) => {
          console.log(error);
        });
      });
    },
    async createPracticeData(pcnId) {
      var data = {
        uuid: uuidv4(),
        openingHours: {},
        interimHours: {},
        holidayHours: {},
        holidays: [],
        deleted: false,
        creationDate: new Date().toISOString(),
        lastModifiedDate: new Date().toISOString(),
        pcnId: pcnId,
        fromParent: true,
        additionalProp1: {}
      };
      return await new Promise((resolve)=>{
        api.post(`/api/pcns/${pcnId}/practice-data`, data)
        .then((response) => {
          resolve(response.data);
        }, (error) => {
          console.log(error);
        });
      });
    },
    async createCms(practiceDataId) {
      var data = {
        uuid: uuidv4(),
        creationDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        practiceDataId: practiceDataId,
        additionalProp1: {}
      };
      return await new Promise((resolve)=>{
        api.post('/api/practice-data/'+practiceDataId+'/cms', data)
        .then((response) => {
          resolve(response.data);
        }, (error) => {
          console.log(error);
        });
      });
    },
    async createCategories(cmsId) {
      const categoryItems = [
        // {
        //     label: 'Meeting & Events',
        //     icon: 'meeting_and_events.svg',
        //     link: '/pages/meetings-events'
        // },
        // {
        //     label: 'Meeting Minutes',
        //     icon: 'meeting_minutes.svg',
        //     link: '/pages/meetings-minutes'
        // },
        // {
        //     label: 'News',
        //     icon: 'network_news.svg',
        //     link: '/pages/pcn-news-edit'
        // },
        // {
        //     label: 'Videos',
        //     icon: 'network_videos.svg',
        //     link: '/pages/video'
        // },
        {
            label: 'Member Practices',
            icon: 'member_practices.svg',
            link: '/pages/member-practices'
        },
        // {
        //     label: 'FAQs',
        //     icon: 'faqs.svg',
        //     link: '/pages/faqs'
        // },
        {
            label: 'PCN Overview',
            icon: 'pcnoverview.svg',
            link: '/network/pcnoverview'
        },
        {
            label: 'PCN Team',
            icon: 'pcnteam.svg',
            link: '/network/pcnteam'
        },
        {
            label: 'PCN Services',
            icon: 'pcnservices.svg',
            link: '/network/pcnservices'
        },
        {
            label: 'Documents',
            icon: 'documents.svg',
            link: '/network/documents'
        },
        {
            label: 'Extended Hours',
            icon: 'extendedhours.svg',
            link: '/network/extendedhours'
        },
      ];

      for(let cat of categoryItems) {
        console.log(cat.label);
        var result = await this.createSubCategory(cmsId, cat);
        console.log('res', result);
        await this.sleep(5);
      }
    },
    async createSubCategory(cmsId, cat) {
      let additionalProps = {}
      switch(cat.label) {
        case 'PCN Overview':
          Object.assign(additionalProps, {
            "logo": "",
            "extended_hours": true,
            "governance_team_title": "Governance Board Members",
            "governance_team_description": "",
            "image": "",
            "what_is_pcn_check": true,
            "pcn_team_check": true,
            "page_title": "",
            "link": "/network/pcnoverview",
            "governance_team": true,
            "member_practices": true,
            "text": "",
            "footnote": "",
            "what_is_pcn": false,
            "icon": "pcnoverview.svg",
            "pcn_service_check": true
          })
          break;
        case 'PCN Team':
          Object.assign(additionalProps, {
            "text": "",
            "groups": [
              {
                "description": "<p>Care Navigators working in practice reception teams are specially trained to know about the care and services available to you at your surgery and in your area. While the name of this role may differ in your practice, they’ll listen and talk to you in confidence about your health problem, to understand your needs so they can book you an appointment with the right healthcare professional or service.&nbsp;<br><br>They can help you:</p><ul><li>Get seen as soon as possible</li><li>Know whether self-referral is available for certain services at your practice or in your area</li><li>Make appointments for new kinds of care or new services you may not be aware of</li><li>Access the appropriate healthcare professional</li></ul>",
                "active": true,
                "id": "5fa95842-c48d-4e5f-b1a0-cb5f1942a5d7",
                "name": "Doctor",
                "title": "Care Navigators / Reception Team",
                "logo": "/docs/pcn_groups/carenavigators.svg"
              },
              {
                "description": "<p>Care Navigators working in practice reception teams are specially trained to know about the care and services available to you at your surgery and in your area. While the name of this role may differ in your practice, they’ll listen and talk to you in confidence about your health problem, to understand your needs so they can book you an appointment with the right healthcare professional or service.&nbsp;<br><br>They can help you:</p><ul><li>Get seen as soon as possible</li><li>Know whether self-referral is available for certain services at your practice or in your area</li><li>Make appointments for new kinds of care or new services you may not be aware of</li><li>Access the appropriate healthcare professional</li></ul>",
                "subgroups": [],
                "id": "c4614ef3-1d79-495a-a958-3137469aace1",
                "active": true,
                "title": "Clinical Pharmacists",
                "logo": "/docs/pcn_groups/clinicalpharmacists.svg"
              },
              {
                "description": "<p>Physiotherapists in general practice are experts in musculoskeletal conditions. They are able to assess, diagnose and treat a range of complex muscle and joint conditions - preventing the need for referrals to hospital. They can arrange swift access to further treatment, investigations and specialists when needed.</p><p>They can help with:</p><ul><li>Diagnosing and treating muscular and joint conditions</li><li>Advising on how to manage your condition</li><li>Referrals on to specialist services</li></ul>",
                "subgroups": [],
                "id": "bee20770-c993-4ed7-bac7-0646877bc2c1",
                "active": true,
                "title": "Physiotherapists",
                "logo": "/docs/pcn_groups/physiotherapists.svg"
              },
              {
                "description": "<p>Paramedics work in a variety of roles within a general practice. Their background in pre-hospital care means that they are used to working with people with a variety of health conditions from coughs and minor injuries to more serious conditions such as asthma and heart attacks. They work alongside GPs and help manage routine or urgent appointments, telephone triage (assessment of urgency of illness or injury) and home visits.</p><p>They can help with:</p><ul><li>Diagnosing and treating health conditions</li><li>Ordering tests and interpreting results</li><li>Supporting people with long-term conditions such as arthritis and diabetes</li></ul>",
                "subgroups": [],
                "id": "cf7cf8e8-117c-44cc-aacc-3ad8c4fac883",
                "active": true,
                "title": "Paramedics",
                "logo": "/docs/pcn_groups/paramedics.svg"
              },
              {
                "description": "<p>Physician Associates are trained and qualified to diagnose and treat a wide range of health conditions. They work alongside GPs to provide care to people, particularly those with long-term conditions who often benefit from being able to see the same healthcare professional.</p><p>They can help with:</p><ul><li>Diagnosing and treating health conditions</li><li>Arranging tests and analysing results</li><li>Performing physical examinations</li></ul>",
                "subgroups": [],
                "id": "339e2c49-28c2-4792-af3f-4fa816ba7da9",
                "active": true,
                "title": "Physician Associates",
                "logo": "/docs/pcn_groups/physicianassociates.svg"
              },
              {
                "description": "<p>Social prescribing involves helping people to improve their health and wellbeing by connecting them to activities in the community. Link Workers connect those feeling lonely, overwhelmed or in need of help to a range of local support, from community and activity groups to work, debt or housing advice.&nbsp;</p><p>They can help with:</p><ul><li>Getting people to focus on their own priorities and the things that affect their wellbeing</li><li>Supporting people to takemore control of their health</li><li>Introducing people to groups and activities in their community</li></ul>",
                "subgroups": [],
                "id": "ddbb4179-39dd-4629-9993-9d0024e87005",
                "active": true,
                "title": "Social Prescribing Link Workers",
                "logo": "/docs/pcn_groups/linkworkers.svg"
              },
              {
                "description": "<p>Healthcare Assistants work under the guidance of a nurse or another healthcare professional. They help with routine health checks and provide patients with general health and wellbeing advice.</p><p>They can help with:</p><ul><li>Health checks, such as blood pressure monitoring or taking blood samples</li><li>Vaccinations and injections</li><li>Healthy living advice, e.g. stopping smoking and weight loss</li><li>Dressings and stitch removal</li></ul>",
                "subgroups": [],
                "id": "77838477-1f1b-4761-aa41-681c3026b5dd",
                "active": true,
                "title": "Healthcare Assistants",
                "logo": "/docs/pcn_groups/healthcareassistants.svg"
              },
              {
                "description": "<p>Nurses in general practice undertake a wide range of roles and are involved in almost every aspect of a patient’s care, assessing, screening and treating people of all ages. In addition to providing traditional aspects of nursing care such as wound care, immunisations and administration of medicines, they run health checks and clinics for those with long-term conditions such as asthma, heart disease and diabetes.&nbsp;</p><p>They can help with:</p><ul><li>Vaccinations and injections</li><li>Supporting people with long-term conditions such as asthma and diabetes</li><li>Healthy living advice e.g. stopping smoking and weight loss</li><li>Family planning and sexual health advice, including smear tests</li></ul>",
                "subgroups": [],
                "id": "5186d883-b30b-40b0-8a34-cd7db3574b3d",
                "active": true,
                "title": "General Practice Nurses",
                "logo": "/docs/pcn_groups/gpnurses.svg"
              },
              {
                "description": "<p>GPs oversee all aspects of patient care. They meet regularly with other members of the practice team to plan joint approaches to coordinate a patient’s care. All other members of the practice team work under the supervision of a GP.</p><p>They can help with:</p><ul><li>Diagnosing and treating a health condition</li><li>Ordering tests and interpreting results</li><li>Prescribing medication where necessary</li><li>Referring you to hospital and other medical services for urgent and specialist treatment</li></ul>",
                "subgroups": [],
                "id": "d3cf3e35-f887-4252-ae01-9d642408fe64",
                "active": true,
                "title": "General Practitioners",
                "logo": "/docs/pcn_groups/generalpractioners.svg"
              },
              {
                "description": "<p>Dieticians help people to improve their health by providing specialist nutrition and diet advice to prevent the onset of diseases like diabetes.</p><p>They can help with:</p><ul><li>Educating patients on how a good diet can improve their health and prevent diseases</li><li>Helping people adopt healthier eating and drinking habits</li><li>Supporting patients of all ages with diet related disorders</li></ul>",
                "subgroups": [],
                "id": "ea2d2917-df99-4cef-8a02-69f6cd60ae61",
                "active": true,
                "title": "Dieticians",
                "logo": "/docs/pcn_groups/dieticians.svg"
              },
              {
                "description": "<p>A Health and Wellbeing Coach supports patients in taking a more active role in their own health and wellbeing with achievable goals.</p><p>They can help with:</p><ul><li>Devising personalised care plans to encourage healthy eating and exercise</li><li>Supporting people to establish and attain goals that will improve their health</li><li>Coaching and motivating people to take more control of their health and fitness</li></ul>",
                "subgroups": [],
                "id": "24082495-fb3c-4a1c-a4fc-f8125d865071",
                "active": true,
                "title": "Wellbeing Coaches",
                "logo": "/docs/pcn_groups/wellbeingcoaches.svg"
              },
              {
                "description": "",
                "subgroups": [],
                "id": "0d856193-04d2-48f0-a658-038d9e5231e0",
                "active": true,
                "title": "Management",
                "logo": "/docs/pcn_groups/management.svg"
              },
              {
                "description": "",
                "subgroups": [],
                "id": "3e95c9f0-6afb-459b-b61b-59deb29fa6d4",
                "active": true,
                "title": "Governance Team",
                "logo": "/docs/pcn_groups/governanceteam.svg"
              }
            ],
            "link": "/network/pcnteam",
            "icon": "pcnteam.svg",
            "description": {
              "text": "<p>Services in general practice and the community are being transformed to make it easier for you to access a wider range of help from your surgery. This is part of the NHS Long Term Plan to offer people further choice and more joined-up healthcare.&nbsp;<br><br>More healthcare professionals including Clinical Pharmacists, Physiotherapists, Paramedics, Physician Associates, Dieticians, Health and Wellbeing Coaches, and Social Prescribing Link Workers are being recruited nationally to work alongside GPs in wider networks of practices. This means you will be able to access more services closer to home.</p>"
            }
          })          
          break;
        case 'PCN Services':
          Object.assign(additionalProps, {
            "related_information": [
              {
                "value": true,
                "name": "Practice Location"
              },
              {
                "value": true,
                "name": "Practice Team"
              },
              {
                "value": true,
                "name": "GP & Nurse Availability"
              },
              {
                "value": true,
                "name": "When we are Closed"
              },
              {
                "value": true,
                "name": "Contact Us"
              }
            ],
            "link": "/network/pcnservices",
            "icon": "pcnservices.svg",
            "description": ""
          })
          break;
        case 'Documents':
          Object.assign(additionalProps, {
            "beta": true,
            "coming_soon": false,
            "link": "/network/documents",
            "icon": "documents.svg"
          })
          break;
        case 'Extended Hours':
          Object.assign(additionalProps, {
            "description": "",
            "icon": "extendedhours.svg",
            "beta": false,
            "coming_soon": false,
            "title": "Extended Hours",
            "link": "/network/extendedhours"
          })
          break;
        default: 
          Object.assign(additionalProps, {
            "icon": cat.icon,
            "link": cat.link,
            "beta": false,
            "coming_soon": false,
          })
      }
      var data = {
        uuid: uuidv4(),
        name: cat.label,
        creationDate: new Date().toISOString(),
        updatedDate: new Date().toISOString(),
        cmsId: cmsId,
        fields: {},
        additionalProp1: additionalProps
      };
      return await new Promise((resolve)=>{
        api.post('/api/cms/'+cmsId+'/categories', data)
        .then((response) => {
          resolve(response.data);
        }, (error) => {
          console.log(error);
        });
      });
    },
    async create(val) {
      // console.log('val', val)
      // if(val.name && val.dynamo && val.url) {
      //   console.log('val', val)
      // }
      // else {
      //   Swal.fire("Invalid Input!", "ODS Code, Practice Name and URL are mandatory.", "error");
      // }
      var stp = await this.createStp(val);
      var ccg = await this.createCcg(val, stp.id);
      var pcn = await this.createPcn(val, ccg.id);

      var pcn_pracData = await this.createPracticeData(pcn.id);
      var pcn_cms = await this.createCms(pcn_pracData.id);
      await this.createCategories(pcn_cms.id);


      var new_pcn = {
        "id": stp.id,
        "code":stp.code,
        "name":stp.name,
        "region_code":stp.region_code,
        "region_name":stp.region_name,
        "ccgs":[
          {"id":ccg.id,
          "code":ccg.code,
          "name":ccg.name,
          "stpId":stp.id,
          "pcns":[
            {"id":pcn.id,
            "code":pcn.code,
            "name":pcn.name,
            "ccgId":ccg.id,
            }]
          }]
        };

      this.pcns.push(new_pcn);
      // console.log('before getting')
    },
    getStpsWithRels() {
      var filter = {
        "include": [
          {
            "relation": "ccgs",
            "scope": {
              "include": [
                {
                  "relation": "pcns"
                }
              ]
            }
          }
        ]
      };
      api.get(`/api/stps?filter=${JSON.stringify(filter)}`)
      .then(res => {
        console.log('data', res.data)
        this.pcns = res.data;
      })
      .catch(e => {
        this.errors.push(e)
      })   
    }
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
    this.getStpsWithRels();
  },
};
</script>

<template>
  <Layout>
    <Heading :page="page" @created="create"></Heading>

    <div class="row">
      <div class="col-12">
        <div class="mt-3">
          <div class="d-flex">
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                  Show&nbsp;
                  <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>&nbsp;entries
                </label>
              </div>
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                <label class="d-inline-flex align-items-center">
                  Search:
                  <b-form-input
                    v-model="filter"
                    type="search"
                    placeholder="Search..."
                    class="form-control form-control-sm ml-2"
                  ></b-form-input>
                </label>
              </div>
            </div>
            <!-- End search -->
          </div>
          <!-- Table -->
          <div class="table-responsive table-striped mb-0">
            <b-table
              :items="pcns"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
            >
            <template v-slot:cell(pcncode)="row">
              <div class="font-size-16">
                {{row.item.ccgs[0].pcns[0].code}}
              </div>
            </template>
            <template v-slot:cell(pcnname)="row">
              <div class="font-size-16">
                {{row.item.ccgs[0].pcns[0].name}}
              </div>
            </template>
            <template v-slot:cell(ccgcode)="row">
              <div class="font-size-16">
                {{row.item.ccgs[0].code}}
              </div>
            </template>
            <template v-slot:cell(ccgname)="row">
              <div class="font-size-16">
                {{row.item.ccgs[0].name}}
              </div>
            </template>
            <template v-slot:cell(stpcode)="row">
              <div class="font-size-16">
                {{row.item.code}}
              </div>
            </template>
            <template v-slot:cell(stpname)="row">
              <div class="font-size-16">
                {{row.item.name}}
              </div>
            </template>
            <template v-slot:cell(regioncode)="row">
              <div class="font-size-16">
                {{row.item.region_code}}
              </div>
            </template>
            <template v-slot:cell(regionname)="row">
              <div class="font-size-16">
                {{row.item.region_name}}
              </div>
            </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.table td {
  border-top: 1px solid #dadce3 !important;
}
.table th {
  border-top: 1px solid #dadce3 !important;
}
</style>